import exchangeImage from '../assets/images/slide__exchange1.png';
import paymentImage from '../assets/images/slide__payment1.png';
import identifyingImage from '../assets/images/slide__identifying1.png';
import sortingImage from '../assets/images/slide__sorting1.png';
import extraImage from '../assets/images/slide__extra1.png';
import printerImage from '../assets/images/slide__printer1.png';
import colorsImage from '../assets/images/slide__colors1.png';
import exchangeSolImg from '../assets/images/slide__exchange-sol.png';
import paymentSolImg from '../assets/images/slide__payment-sol.png';
import identifyingSolImg from '../assets/images/slide__identifying-sol.png';
import lockSolImg from '../assets/images/slide__lock-sol.png';
import favoriteSolImg from '../assets/images/slide__favorite-sol.png';
import lessClickSolImg from '../assets/images/slide__lessClick-sol.png';
import recieptsSolImg from '../assets/images/slide__reciepts-sol.png';
import colorsSolImg from '../assets/images/slide__colors-sol.png';

import colorslImg from '../assets/images/colorsImg.png';

export const exchangeSlideData = {
  text: `The exchange function requires two actions - return and sale - which can take up a lot of time

    This reduces the convenience of cashiers and customers and increases the time of the exchange
    
    Also this makes it difficult to track exchange statistics`,
  problem: 'Problem #1',
  title: 'Exchange',
  image: exchangeImage,
};

export const paymentSlideData = {
  text: `Making mix payments using cash and credit cards is not possible, which could reduce customer loyalty

    In case of problems with payment, this situation can put the client in an awkward position`,
  problem: 'Problem #2',
  title: 'Mix payment',
  image: paymentImage,
};

export const identifyingAndWorkspaceSlideData = {
  text: `Cashier name being out of sight leads to confusion`,
  problem: 'Problem #3',
  title: 'Identifying the cashier',
  additionalText: `Cashiers are often unable to leave their workplace because the system is open`,
  additionalProblem: 'Problem #4',
  additionalTitle: 'Unable to leave workspace',
  image: identifyingImage,
};

export const sortingSlideData = {
  text: `The current system does not allow users to add frequently requested products to favorites, making it time-consuming to search for items

    This increases the time the cashier spends on each sale`,
  problem: 'Problem #5',
  title: 'Sorting goods',
  image: sortingImage,
};

export const extraActionsSlideData = {
  text: `Sometimes users go through unnecessary steps, while important steps are missed in other places

    For instance, reaching the 'Discard' button requires one extra click, whereas the cancellation itself occurs without additional confirmation`,
  problem: 'Problem #6',
  title: 'Extra actions and missed actions',
  image: extraImage,
};

export const printerSlideData = {
  text: `Running out of printer ribbon in the receipt printer often disrupts work
    
    Excessive use of cash register paper is also bad for the environment. To create it you need a lot of paper, and after use it instantly turns into garbage`,
  problem: 'Problem #7',
  title: 'Printer ribbon replacing',
  image: printerImage,
};

export const colorsSlideData = {
  text: `The bright and colorful system can become annoying and eye-straining at the end of a long shift

    The interview results showed that store employees prefer to use more relaxed interfaces`,
  problem: 'Problem #8',
  title: 'Too many colors',
  image: colorsImage,
};

// Solution

export const exchangeSolutionSlideData = {
  text: `The old exchange function required two actions, return and sale, which took time. The new solution combines these actions into one function, making the exchange process faster and more efficient
  
  Additionally, users can split the bill into two fields: items for return and items for exchange, and complete the exchange with a refund or surcharge as needed`,
  problem: 'Solution #1',
  title: 'Exchange',
  image: exchangeSolImg,
};

export const paymentSolutionSlideData = {
  text: `Making a mix payment - cash and credit card - was impossible, potentially reducing customer loyalty

  The new system introduces the ability to make a mix payment - cash, credit card, as well as the possibility of paying with a gift card`,
  problem: 'Solution #2',
  title: 'Mix payment',
  image: paymentSolImg,
};

export const identifyingSolutionSlideData = {
  text: `Previously, the cashier's name was not clearly visible, which could lead to confusion and mix-ups at cash registers

  In the updated system, the cashier's name is prominently displayed on the system line, reducing the likelihood of confusion with cash desks`,
  problem: 'Solution #3',
  title: 'Cashier’s name on a system line',
  image: identifyingSolImg,
};

export const lockSolutionSlideData = {
  text: `Cashiers often don't have the option to leave their workplace as they can't leave the system open

  The new system has a button to lock the system`,
  problem: 'Solution #4',
  title: 'Lock the system feature',
  image: lockSolImg,
};

export const favoriteItemsSolutionSlideData = {
  text: `It wasn’t possible to add a frequently requested product to favorites. And it took a very long time to search for goods through groups

  In the new system, you can add products to your favorites in just a click. Thus, the cashier can customize the list of items`,
  problem: 'Solution #5',
  title: 'Favorites items',
  image: favoriteSolImg,
};

export const lessClickSolutionSlideData = {
  text: `Previously, additional button presses prolonged the process and consumed valuable time. In the new system, I aimed to simplify the user experience by reducing the user path

  The "Cancel", "Postpone", and "Discount" buttons are now prominently displayed and readily accessible, saving the user one click
  
  Additionally, the item groups are now always displayed on the main screen, further streamlining the user's path by two clicks`,
  problem: 'Solution #6',
  title: 'Less clicks',
  image: lessClickSolImg,
};

export const recieptsSolutionSlideData = {
  text: `Cashiers are frequently disrupted from their work by running out of printer ribbon for the receipt printer

  The new system offers the option to print a cash receipt or send it via email or SMS, reducing the need for paper receipts, saving time on changing ribbon, and providing more convenience for customers and the environment`,
  problem: 'Solution #7',
  title: 'Digital receipts',
  image: recieptsSolImg,
};

export const colorsSolutionSlideData = {
  text: `Too bright and colorful system becomes annoying at the end of the shift. And it can also make their eyes tired

  The new system uses far fewer bright colors`,
  color: colorslImg,
  problem: 'Solution #8',
  title: 'Calmer colors',
  image: colorsSolImg,
};